import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function SubscriptionBasicInfoComponent ({programs,handleInnerFormChange, subscriptionDetails}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer

label="Name"
name="Name"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'Name'
  );
}}
type="text"
value={subscriptionDetails?.Name}
/>
<InputContainer

label="Email"
name="Email"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'Email'
  );
}}
type="text"
value={subscriptionDetails?.Email}
/>
<InputContainer
    isRequired
    label="Calling Code"
    name="CallingCode"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'CallingCode'
           );
    }}
    placeholder="Enter your Country Code"
    type="text"
    value={subscriptionDetails?.CallingCode}
/>
<InputContainer

label="PhoneNumber"
name="PhoneNumber"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'PhoneNumber'
  );
}}
type="text"
value={subscriptionDetails?.PhoneNumber}
/>

<InputContainer
              label="Program Name"
              labelField="Name"
              list={programs}
              onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'OwnerId');
                }
              }
              optionName='choose Programs'
              type="select"
              value={subscriptionDetails?.OwnerId}
              valueField="Id"
            />


<InputContainer

label="Validity"
    labelField="Description"
    list={libraryData?.result?.MembershipLength}
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'Validity'
  );
}}
optionName='choose Validity Months'
              type="select"
value={subscriptionDetails?.Validity}
valueField="Description"
/>

<InputContainer

label="Amount"
name="Amount"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'Amount'
  );
}}
type="number"
value={subscriptionDetails?.Amount}
/>
<div className='col-span-full'>
<InputContainer

label="Description"
name="Description"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'Description'
  );
}}
type="text"
value={subscriptionDetails?.Description}
/>        </div>
  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>


        </>
  )
}